<template>
  <div>
    <div class="videoReview">
      <div class="reviewtitle u-flex u-flex-between">
        <span>评论管理</span>
        <span class="select_showreel" @click="opendraw">选择作品</span>
      </div>
      <div class="u-flex videoReview_top " v-if="videoCurrentList.videoInfo">
        <div class="left_videoimg" style="border: 1px solid rgba(0,0,0,.1);background-color: darkgray;border-radius: 4px;">
          <img :src="imgsrc + videoCurrentList.videoInfo.coverImg" alt="" srcset="">
        </div>
        <div class="u-flex-y right_top_title">
          <div class="myfontwidth2">
           {{videoCurrentList.videoInfo.videoContent}}
          </div>
          <div class="time">
           {{fifTime(videoCurrentList.videoInfo.publishTime)}}
          </div>
        </div>
      </div>
      <div v-else class="emitdata">
          <img  style="width: 300px;height: 150px;" src="/static/person/buy_emit.png" alt="">
          <div class="eemit_txt">
              暂无评论数据
          </div>
      </div>

      <div>
        <!-- 评论管理 -->
        <div class="smalltitle">
          评论管理
        </div>
        <div class="u-flex sendmsg u-flex-items-center" >
          <div>
            <img :src="userInfoData.avatar?userInfoData.avatar:'/static/news/nouser.png'" alt="" srcset="">
          </div>
          <div class="editinput">
            <el-input v-model="commentReplytxt" placeholder="快去发表属于自己的评论吧！！！"></el-input>
          </div>
        </div>

        <div class="btnsendmsg">
          <span @click="replyCurrentVideo" :class="commentReplytxt?'bgactive':''">发表</span>
        </div>
        <div style="margin-bottom: 24px;">
          <el-select v-model="sortOrder" @change="changeSelect" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="userrevewinfo u-flex" style="margin-top: 8px;" v-for="(item,index) in revewList" :key="index">
          <div class="userinfoimg" v-if="item.commentUserData">
            <img :src="item.commentUserData.avatar" alt="" srcset="">
          </div>
          <div class="revewdata">
            <div class="usertitle u-flex-y">
              <span>{{item.commentUserData.nickname}} <span style="font-size: 12px;color: #fff;background-color: crimson;padding: 0px 2px;border-radius: 3px;" v-if="item.uId  ==videoCurrentList.videoInfo.uId">作者</span></span>
              <span class="datastatus">{{fifTimes(item.commentTime)}}</span>
            </div>
            <div class="revewcnt">
              <div class="myfontwidth2">
              {{item.commentContent}}
              </div>
              <div class="u-flex u-flex-items-center handlerevew">
                <span @click="likeComment(item)"><img src="/static/center/guanzhu.png" alt="" srcset="">{{item.likeNum}}</span>
                <span @click="setreadem(item)"><img src="/static/center/pinglun.png" alt="" srcset="">回复</span>
                <span @click="delcommentPlay(item)"><img src="/static/center/shanchu.png" alt="" srcset="">删除</span>
              </div>
            </div>
            <!-- 二级评论 -->
            <div class="u-flex succendsendmsg u-flex-items-center" v-if="item.edit &&item.commentId == readem">
               <div>
                 <img :src="userInfoData.avatar?userInfoData.avatar:'/static/news/nouser.png'" alt="" srcset="">
               </div>
               <div class="editinput">
                 <el-input v-model="commentReplytxt2" placeholder="快去发表属于自己的评论吧！！！"></el-input>
                 <div class="btnclickmsg" @click="comentplay2(false,item)">
                   发表
                 </div>
               </div>
             </div>
            <div v-if="item.showchild">
              <div  class="userrevewinfo secondrevew u-flex" v-for="(items,index) in item.child">
                 <div class="userinfoimg" v-if="items.commentUserData">
                   <img :src="items.commentUserData.avatar" alt="" srcset="">
                 </div>
                 <div class="revewdata">
                   <div class="usertitle u-flex-y">
                     <span>{{items.commentUserData.nickname}}<span style="font-size: 12px;color: #fff;background-color: crimson;padding: 0px 2px;border-radius: 3px;margin-left: 4px;" v-if="items.uId  == videoCurrentList.videoInfo.uId ">作者</span></span>
                     <span class="datastatus">{{ fifTimes(item.commentTime)}}</span>
                   </div>
                   <div class="revewcnt">
                     <div class="myfontwidth2">
                     <span v-if="items.toUserData">回复&nbsp;{{items.toUserData.nickname}}：&nbsp;</span>{{items.commentContent}}</div>
                     <div class="u-flex handlerevew">
                       <span  @click="likeComment(item,items)"><img src="/static/center/guanzhu.png" alt="" srcset="">{{items.likeNum}}</span>
                       <span  @click="setreadem(items)"><img src="/static/center/pinglun.png" alt="" srcset="">回复</span>
                       <span @click="delcommentPlay(item,items)"><img src="/static/center/shanchu.png" alt="" srcset="">删除</span>
                     </div>
                     <div>
                     </div>
                   </div>
                   <div class="u-flex succendsendmsg u-flex-items-center" v-if="items.edit &&items.commentId == readem">
                     <div>
                        <img :src="userInfoData.avatar?userInfoData.avatar:'/static/news/nouser.png'" alt="" srcset="">
                     </div>
                     <div class="editinput">
                       <el-input v-model="commentReplytxt2" placeholder="快去发表属于自己的评论吧！！！"></el-input>
                       <div class="btnclickmsg"  @click="comentplay2(item,items)">
                         发表
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
            </div>
            <div @click="openchild(item)" v-if="item.commentNum" style="margin-top: 14px;cursor: pointer;color: #999999;font-size: 13px;">
              —— {{item.showchild?'收起':'展开'}} <b> {{item.child.length>0?item.child.length:item.commentNum}}</b> 条回复  <i :class="item.showchild?'trange':''" class="el-icon-arrow-down"></i>
            </div>

          </div>
        </div>
        <div class="userrevewinfo u-flex"  v-if="false">
          <div class="userinfoimg">
            <img src="/static/room/cuigeng.png" alt="" srcset="">
          </div>
          <div class="revewdata">
            <div class="usertitle u-flex-y">
              <span>正在向用户名称</span>
              <span class="datastatus">昨天</span>
            </div>
            <div class="revewcnt">
              <div class="myfontwidth2">这个视频解析的特别棒</div>
              <div class="u-flex handlerevew">
                <span><img src="/static/center/guanzhu.png" alt="" srcset=""> 0</span>
                <span><img src="/static/center/pinglun.png" alt="" srcset="">回复</span>
                <span><img src="/static/center/shanchu.png" alt="" srcset="">删除</span>
              </div>
            </div>

            <div class="userrevewinfo secondrevew u-flex">
              <div class="userinfoimg">
                <img src="/static/room/cuigeng.png" alt="" srcset="">
              </div>
              <div class="revewdata">
                <div class="usertitle u-flex-y">
                  <span>正在向用户名称</span>
                  <span class="datastatus">昨天</span>
                </div>
                <div class="revewcnt">
                  <div class="myfontwidth2">这个视频解析的特别棒</div>
                  <div class="u-flex handlerevew">
                    <span><img src="/static/center/guanzhu.png" alt="" srcset=""> 0</span>
                    <span><img src="/static/center/pinglun.png" alt="" srcset="">回复</span>
                    <span><img src="/static/center/shanchu.png" alt="" srcset="">删除</span>
                  </div>
                </div>
                <div class="u-flex succendsendmsg u-flex-items-center">
                  <div>
                    <img src="/static/room/cuigeng.png" alt="" srcset="">
                  </div>
                  <div class="editinput">
                    <el-input v-model="input" placeholder="快去发表属于自己的评论吧！！！"></el-input>
                    <div class="btnclickmsg">
                      发表
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="userrevewinfo secondrevew u-flex">
              <div class="userinfoimg">
                <img src="/static/room/cuigeng.png" alt="" srcset="">
              </div>
              <div class="revewdata">
                <div class="usertitle u-flex-y">
                  <span>正在向用户名称</span>
                  <span class="datastatus">昨天</span>
                </div>
                <div class="revewcnt">
                  <div class="myfontwidth2">
                    <span>回复&nbsp;</span>
                    张三同学：&nbsp;这个视频解析的特别棒
                  </div>
                  <div class="u-flex handlerevew">
                    <span><img src="/static/center/guanzhu.png" alt="" srcset=""> 0</span>
                    <span><img src="/static/center/pinglun.png" alt="" srcset="">回复</span>
                    <span><img src="/static/center/shanchu.png" alt="" srcset="">删除</span>
                  </div>
                </div>
                <div class="u-flex succendsendmsg u-flex-items-center">
                  <div>
                    <img src="/static/room/cuigeng.png" alt="" srcset="">
                  </div>
                  <div class="editinput">
                    <el-input v-model="input" placeholder="快去发表属于自己的评论吧！！！"></el-input>
                    <div class="btnclickmsg">
                      发表
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="u-flex succendsendmsg u-flex-items-center">
              <div>
                <img src="/static/room/cuigeng.png" alt="" srcset="">
              </div>
              <div class="editinput">
                <el-input v-model="input" placeholder="快去发表属于自己的评论吧！！！"></el-input>
                <div class="btnclickmsg">
                  发表
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer custom-class="demo-drawer" ref="drawer" :visible.sync="drawerdrawerList" direction="rtl"
      :before-close="handleClose">
      <div class="headername" slot="title">
        <span>作品列表</span>
        <span style="font-size: 14px;">(共{{videotypeList.length}}个作品)</span>
      </div>
      <div class="Videolist">
        <div class="u-flex videoReview_top" :class="videoCurrentIndex == index?'Activeselect':''"  @click="changeVideo(item,index)"  v-if="item.videoInfo && item.videoInfo.flag == 0" v-for="(item,index) in videotypeList" :key="index">
          <div class="left_videoimg">
            <img :src="imgsrc + item.videoInfo.coverImg" alt="" srcset="">
          </div>
          <div class="u-flex-y right_top_title">
            <div class="myfontwidth2">
              {{item.videoInfo.videoContent}}
            </div>
            <div class="time">
                {{fifTime(item.videoInfo.publishTime)}}
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
  import ROOTURLS from '@/api/lz.js'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format';
  momentDurationFormatSetup(moment);
  import {
    videoDraftlist,
    videoDraftdelete,
    publishList,
    commentList,
    commentReply,
    VideoComment,
    videodel,commentDel,
    commentLike,
    childCommentList,
    getUserInfo
  } from '@/api/video.js'
  export default {
    data() {
      return {
        imgsrc:'',
        commentReplytxt:'',
        commentReplytxt2:'',
        userInfoData:{},
        input: '',
        firstReqTime:'',
        readem:'',
        drawerdrawerList: false,
        videotypeList:[],
        videoCurrentList:{},
        videoCurrentIndex:0,
        sortOrder:'',
        revewList:[],
        options: [{
          value: '1',
          label: '按点赞量排序'
        }, {
          value: '3',
          label: '按评论时间排序'
        }, {
          value: '2',
          label: '按评论数量排序'
        }],
        value: ''
      }
    },
    created() {
      this.imgsrc = ROOTURLS.ImgpagaUrl
        this.initData()
    },
    methods: {
      // 切换视频评论
      changeSelect(e){
        console.log(e);
        this.getCommnetreply()
      },
      // 切换视频
      changeVideo(val,index){
        if(val){
          this.videoCurrentList = val;
          this.videoCurrentIndex = index;
           this.getCommnetreply()
        }
      },
      // 评论当前视频
      async replyCurrentVideo(){
        if(this.commentReplytxt =='' || !this.commentReplytxt){
          this.$message.error('评论内容不能为空~');
          return
        }


        if(this.videotypeList.length == 0){
          this.$message.error('您还未发布作品');
          return
        }

        // if(this.videoCurrentList.videoInfo && !this.videoCurrentList.videoInfo.videoId){

        // }
        let keyWord = await  this.$store.dispatch('fifWord',{key:"commonSendlist",value:this.commentReplytxt})
        if(keyWord.state){
          this.commentReplytxt = keyWord.value;
        }else{
          return
        }



        this.firstReqTime = ''
        VideoComment({
          videoId: this.videoCurrentList.videoInfo.videoId,
          commentContent:this.commentReplytxt,
        }).then(res=>{
           console.log('评论视频',res);
           this.getCommnetreply();
           this.commentReplytxt = ''
        })
      },
      fifTimes(val){
      	let t1= moment(val * 1000);
      	let t2 = moment();
      	let status = '';
      	if(t2.diff(t1, 'day') > 0){
      	  let days =  t2.diff(t1, 'day');
      	  if(days >= 4){
      	    return moment(val * 1000).format('YYYY-MM-DD')
      	  }else{
      	    status = days +'天前'
      	    return status
      	  }

      	}
      	if(t2.diff(t1, 'hour') > 0){
      		status = t2.diff(t1, 'hour') +'小时前'
      		return status
      	}

      	if(t2.diff(t1, 'minutes') > 0){
      		status = t2.diff(t1, 'minutes') +'分钟前'
      		return status
      	}
      	if(t2.diff(t1, 'seconds') >= 0){
      		status = '刚刚'
      		return status
      	}
      	console.log();//实际相差多少天 ， 第二个参数是单位


      	 // moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
      },
      // 过滤时间
      fifTime(val){
      	let t1= moment(val * 1000);
      	let t2 = moment();
      	let status = '';
      	if(t2.diff(t1, 'day') > 0){
      	  let days =  t2.diff(t1, 'day');
      	  if(days >= 4){
      	    return moment(val * 1000).format('YYYY-MM-DD')
      	  }else{
      	    status = days +'天前'
      	    return status
      	  }

      	}
      	if(t2.diff(t1, 'hour') > 0){
      		status = t2.diff(t1, 'hour') +'小时前'
      		return status
      	}

      	if(t2.diff(t1, 'minutes') > 0){
      		status = t2.diff(t1, 'minutes') +'分钟前'
      		return status
      	}
      	if(t2.diff(t1, 'seconds') >= 0){
      		status = '刚刚'
      		return status
      	}
      	console.log();//实际相差多少天 ， 第二个参数是单位
      	 // moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
      },
      // 评论二级内容
      async comentplay2(values,val){
        if(this.commentReplytxt2 =='' || !this.commentReplytxt2){
          this.$message.error('评论内容不能为空~');
          return
        }

        let keyWord = await  this.$store.dispatch('fifWord',{key:"commonSendlist",value:this.commentReplytxt2})
        if(keyWord.state){
          this.commentReplytxt2 = keyWord.value;
        }else{
          return
        }


        commentReply({
          videoId:val.videoId,
          commentContent:this.commentReplytxt2,
          commentId:val.commentId,
          toUId:val.uId,
          replyType:1,
        }).then(res=>{
          console.log('这是二级评论',res);
          if(res.data.code == 200){
            this.$message.success('评论成功');
            if(values){
              this.getChildCommentList(values)
            }else{
              this.getChildCommentList(val)
            }
            this.commentReplytxt2 = ''
          }
        })
      },
      // 获取二级评论
      getChildCommentList(val){
        childCommentList({
          videoId:val.videoId,
          commentId:val.commentId,
          page:1,
          limit:100,
        }).then(result=>{
          if(result.data.code ==200){
              let index = this.revewList.findIndex(item=>item.commentId==val.commentId);
              this.firstReqTime = result.data.data.firstReqTime;
              let arr =  result.data.data.list;
              this.revewList[index].child = arr.map(item=>{
                item.edit = false;
                return item
              })
              console.log('二级评论',index, this.revewList[index].child);
              this.$forceUpdate()
              this.revewList[index].showchild = true;
          }
        })
      },
      // 获取一级评论
      async getCommnetreply(){
        let result = await commentList({
            videoId: this.videoCurrentList.videoInfo.videoId,
            firstReqTime:this.firstReqTime?this.firstReqTime:'',
            sortOrder:this.sortOrder,
            replyType:0,
            page:1,
            limit:100
          })
            console.log('一级评论列表', result.data.data);
            if(result.data.code == 200){
              this.firstReqTime = result.data.data.firstReqTime;
              let list = result.data.data.list;
              this.revewList = list.map(item=>{
                item.child = [];
                item.edit = false;
                item.showchild = false;
                return item
              })
              this.$forceUpdate()
            }
      },
      async initData(val) {
        let resultData  =  await getUserInfo({

        })
        if(resultData.data.code == 200){
          this.userInfoData = resultData.data.data.userInfo;
          console.log(resultData.data.data.userInfo);
        }
        // 视频管理
       let res= await publishList({
          videoState: 1,
          page: 1,
          limit: 100,
        })
          if (res.data.code == 200) {
            let arrlist = res.data.data.list;
            this.videotypeList = arrlist.map(item => {
              if (item.videoInfo && item.videoInfo.flag == 0) {
                item.videoInfo.samllContent = item.videoInfo.videoContent.substring(0, 92) + '···'
                item.videoInfo.showtxt = false
              }
              return item
            })
            if(this.videotypeList.length>0){
              this.videoCurrentList  = this.videotypeList[this.videoCurrentIndex];
              this.getCommnetreply()
          }
          console.log('列表', this.videotypeList);
          }
      },
      // 删除评论
      delcommentPlay(item,items){
        if(!items){
          commentDel({
            commentId:item.commentId
          }).then(res=>{
            if(res.data.code == 200){
              this.$message.success('删除成功');
              this.getCommnetreply()
            }else{
              this.$message.error('删除失败');
            }
          })
        }else{
          commentDel({
            commentId:items.commentId
          }).then(res=>{
            if(res.data.code == 200){
              this.$message.success('删除成功');
              this.getChildCommentList(item)
            }else{
              this.$message.error('删除失败');
            }
          })
        }

      },
      // 展开回复
      openchild(item){
        console.log('展开了吗',item);
        if(item.showchild === false){
          // 获取二级评论
          this.getChildCommentList(item);
        }else{
          item.showchild = false;
        }
      },
      // 点赞评论
      likeComment(item,items){
        if(!items){
          commentLike({
            videoId:item.videoId,
            commentId:item.commentId,
          }).then(res=>{
            console.log('点赞了',JSON.parse(JSON.stringify(res)));
            if(res.data.data == 0){
              this.$message.success('点赞成功！')
            }else{
              this.$message.success('已取消点赞！')
            }
            this.getCommnetreply()
          })
        }else{
          commentLike({
            videoId:items.videoId,
            commentId:items.commentId,
          }).then(res=>{
            console.log('点赞了2',JSON.parse(JSON.stringify(item)) );
            this.getChildCommentList(item)
          })
        }

      },
      // 回复内容
      setreadem(item){
        this.readem = item.commentId;
        item.edit = true;
      },
      opendraw() {
        this.drawerdrawerList = true;
        // 刷新视频列表
        this.initData()
      },
      handleClose(e) {
        this.drawerdrawerList = false
        // this.$confirm('确认关闭？')
        //   .then(_ => {

        //   })
        //   .catch(_ => {});
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/flex.scss';
  .emitdata{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-height: 30vh;
    flex-direction: column;
    .eemit_txt{
      margin-top: 18px;
      font-size: 16px;
      color: #666;
    }
  }
  .demo-drawer {
    color: #000;
    padding: 0 24px;

    .Videolist {
      .videoReview_top:hover{
        background-color: #F1F1F1;
        transition: all .2s;
        cursor: pointer;
      }
      .Activeselect{
        border: 1px solid #721EDC !important;
      }
      .videoReview_top {
        margin-bottom: 12px;
        background: #F7F8FA;
        border-radius: 8px;
        border: 1px solid #F7F8FA;
        padding: 24px;

        .time {
          margin-top: 18px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .right_top_title {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          justify-content: space-between;
          padding: 12px 0;

        }

        .left_videoimg {
          margin-right: 12px;

          img {
            width: 83px;
            height: 100px;
            border-radius: 8px;
          }
        }
      }
    }

    .headername {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }

  .videoReview {
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    width: calc(1200px - 202px);
    box-sizing: border-box;
    height: calc(100vh - 130px);
    padding: 0 24px;
    box-sizing: border-box;
    overflow-y: scroll;

    /**
     * 二级样式
     **/
    .secondrevew {
      margin-top: 30px;

      .revewdata {
        padding: 0 12px !important;
      }

      .userinfoimg {
        img {
          width: 32px !important;
          height: 32px !important;
          border-radius: 50%;
        }
      }
    }

    .userrevewinfo {
      margin-top: 24px;

      .revewdata {
        flex: 2;
        padding: 10px 12px;
      }

      .btnclickmsg {
        cursor: pointer;
        position: absolute;
        right: 20px;
        bottom: 50%;
        transform: translateY(50%);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #721EDC;
      }

      .succendsendmsg {
        margin-top: 12px;
        flex: 2;

        img {
          width: 32px;
          height: 32px;
          background: #DADADA;
          border-radius: 50%;
        }

        .editinput {
          position: relative;
          flex: 2;
          margin-left: 12px;
        }
      }

      .revewcnt {
        margin-top: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .trange{
          transform: rotate(180deg);
          transition: all .2s;
        }
        .handlerevew {
          max-width: 160px;
          margin-top: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          img {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }

          span {
            // height: 35px;
            align-items: center;
            display: flex;
            font-size: 12px;
            cursor: pointer;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }

      .usertitle {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;

        .datastatus {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
        }
      }

      .userinfoimg {
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
      }
    }

    .smalltitle {
      margin-top: 50px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    .btnsendmsg {
      display: flex;
      justify-content: flex-end;
      .bgactive{
        background-color: #721EDC;
      }
      span {
        text-align: center;
        cursor: pointer;
        width: 64px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        background: #B3B3B3;
        border-radius: 4px 6px 6px 4px;
      }
    }

    .sendmsg {
      margin-top: 24px;

      img {
        width: 60px;
        height: 60px;
        background: #DADADA;
        border-radius: 50%;
      }

      .editinput {
        flex: 2;
        margin-left: 12px;
      }
    }

    .reviewtitle {
      padding: 24px 0;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;

      .select_showreel {
        cursor: pointer;
        width: 90px;
        height: 32px;
        background: #721EDC;
        border-radius: 4px;
        line-height: 32px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }

    .videoReview_top {
      background: #F7F8FA;
      border-radius: 8px;

      padding: 24px;

      .time {
        margin-top: 18px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }

      .right_top_title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        justify-content: space-between;
        padding: 12px 0;

      }

      .left_videoimg {
        margin-right: 12px;

        img {
          width: 83px;
          height: 100px;
          border-radius: 8px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/template/contentreview.vue